import React, { useState } from 'react';
import 'assets/plugins/nucleo/css/nucleo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/scss/argon-dashboard-react.scss';
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Popover,
  PopoverBody,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { handleSendGeneric } from 'services/generic';
import { Notification } from 'notification/notification';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

export const DeleteWithModalButton = ({ urlDelete, idDelete, listUpdate }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleDeleteAction = async (e) => {
    e.stopPropagation();

    try {
      const response = await handleSendGeneric(urlDelete, 'DELETE', idDelete);

      Notification(response, 'Item excluído com sucesso!');

      listUpdate((prevList) =>
        prevList.filter((item) => item?.id !== idDelete),
      );

      setModal(false); // fecha o modal após excluir
    } catch (error) {
      Notification(error, 'Erro ao excluir item');
    }
  };

  return (
    <>
      <Button onClick={() => setModal(true)} color='danger'>
        Excluir
      </Button>
      <Modal isOpen={modal} size='md' fade={false}>
        <ModalBody>Deseja realmente excluir este item?</ModalBody>
        <ModalFooter>
          <Button color='danger' onClick={handleDeleteAction} size='lg'>
            Excluir
          </Button>
          <Button color='secondary' onClick={toggle} size='lg'>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export const ActionTable = ({
  urlEdit,
  urlDelete,
  listUpdate,
  idDelete,
  enableModal,
  enableEdit = false,
}) => {
  let history = useHistory();

  const handleEditAction = () => {
    history.push('/admin' + urlEdit);
  };

  const handleDeleteAction = async (e) => {
    console.log('Delete action triggered for ID:', idDelete);
    e.stopPropagation();
    const response = await handleSendGeneric(urlDelete, 'DELETE', idDelete);
    Notification(response, 'Item excluído com sucesso!');
    listUpdate((listUpdate) =>
      listUpdate.filter((item) => item?.id !== idDelete),
    );
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        className='btn-icon-only text-light'
        role='button'
        size='md'
        color=''
      >
        <i className='ni ni-ui-04 text-info' />
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-arrow' right>
        <div
          style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}
        >
          {!enableEdit && (
            <Button
              onClick={handleEditAction}
              color='info'
              style={{ marginRight: '0px' }}
            >
              Editar
            </Button>
          )}
          <div style={{ padding: '4px' }}></div>
          {enableModal ? (
            <DeleteWithModalButton
              urlDelete={urlDelete}
              idDelete={idDelete}
              listUpdate={listUpdate}
            />
          ) : (
            <Button onClick={handleDeleteAction} color='danger'>
              Excluir
            </Button>
          )}
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export const ActionPopover = ({
  urlEdit,
  urlDelete,
  listUpdate,
  idDelete,
  enableModal,
  enableEdit = false,
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const handleDelete = async (e) => {
    console.log('Delete action triggered for ID:', idDelete);
    e.stopPropagation();
    const response = await handleSendGeneric(urlDelete, 'DELETE', idDelete);
    Notification(response, 'Item excluído com sucesso!');
    listUpdate((listUpdate) =>
      listUpdate.filter((item) => item?.id !== idDelete),
    );
  };

  let history = useHistory();

  const handleEditAction = () => {
    history.push('/admin' + urlEdit);
  };

  return (
    <>
      <Button
        id={`Popover-${idDelete}`}
        className='btn-icon-only text-light'
        color=''
        onClick={toggle}
      >
        <i className='ni ni-ui-04 text-info' />
      </Button>

      <Popover
        placement='bottom'
        isOpen={popoverOpen}
        target={`Popover-${idDelete}`}
        toggle={toggle}
      >
        <PopoverBody
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '15px',
            minWidth: '200px',
          }}
        >
          {!enableEdit && (
            <Button
              color='info'
              size='lg'
              style={{ marginRight: '0px' }}
              onClick={handleEditAction}
            >
              Editar
            </Button>
          )}

          {enableModal ? (
            <DeleteWithModalButton
              urlDelete={urlDelete}
              idDelete={idDelete}
              listUpdate={listUpdate}
            />
          ) : (
            <Button
              color='danger'
              size='lg'
              onClick={handleDelete}
              style={{ marginLeft: '0px' }}
            >
              Excluir
            </Button>
          )}
        </PopoverBody>
      </Popover>
    </>
  );
};
